import FieldProto from "../field-proto";

import SettingsForm from "./components/settings-form";
import FormElement from "./components/form-element";


export default class FormFieldNumber extends FieldProto {

    constructor(config) {
        super(config);

        this.type = gd.const.formFields.type.NUMBER;
    }

    getSettingsForm() {
        return SettingsForm.bind(null, this); // null is needed here as firt argument as it dfines the scope! and second arg is realy arg
    }

    getFormElement() {
        return FormElement.bind(null, this);
    }

    // get View() {
    //     // return FormNewComponent.bind(null, this.customField.id);
    //     return <div>View here</div>
    // }



}